module.exports = __webpack_public_path__ + "img/step1-5.8b363d19.png";